export const ROLE_PERMISSION_LIST_REQUEST = 'ROLE_PERMISSION_LIST_REQUEST'
export const ROLE_PERMISSION_LIST_SUCCESS = 'ROLE_PERMISSION_LIST_SUCCESS'
export const ROLE_PERMISSION_LIST_FAIL = 'ROLE_PERMISSION_LIST_FAIL'

export const CREATE_ROLE_PERMISSION_REQUEST = 'CREATE_ROLE_PERMISSION_REQUEST'
export const CREATE_ROLE_PERMISSION_SUCCESS = 'CREATE_ROLE_PERMISSION_SUCCESS'
export const CREATE_ROLE_PERMISSION_FAIL = 'CREATE_ROLE_PERMISSION_FAIL'

export const DELETE_ROLE_PERMISSION_REQUEST = 'DELETE_ROLE_PERMISSION_REQUEST'
export const DELETE_ROLE_PERMISSION_SUCCESS = 'DELETE_ROLE_PERMISSION_SUCCESS'
export const DELETE_ROLE_PERMISSION_FAIL = 'DELETE_ROLE_PERMISSION_FAIL'

export const RESET_STATE_ROLE_PERMISSION = 'RESET_STATE_ROLE_PERMISSION'
